// src/utils/feedCache.js

export const feedCache = {
    userNewsContent: null,
    activeIndex: 0,
    hasMore: true,
    lastTimestamp: null,
    filters: { postType: '', state: '', district: '', constituency: '', mandal: '' },
    quotesPool: []
};